module.exports = __webpack_public_path__ + "img/$.b9698b86.png";